import { FLOWCODE_ROOT } from '@dtx-company/true-common/src/constants/root'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { resolveHref } from 'next/dist/client/resolve-href'
import Router from 'next/router'

// for some payment methods user will be redirected to confirmationRedirectURL as soon as user confirm or decline payment.
// This URL will be opened in a new tab, on the device where the payment confirmation was initiated (most common  on the mobile device).
export const confirmationRedirectURL = `${FLOWCODE_ROOT}${resolveHref(
  Router,
  { pathname: Routes.ACCOUNT },
  false
)}`
